export function parseJsonSafe<T>(value: unknown, context?: string): T | null {
  if (typeof value !== 'string') {
    return (value as T) ?? null;
  }

  try {
    return JSON.parse(value) as T;
  } catch (error) {
    const message = context ?? 'parseJsonSafe';
    console.error(`${message}:`, error);
    return null;
  }
}

export function ensureArray<T>(value: unknown): T[] {
  return Array.isArray(value) ? (value as T[]) : [];
}
